<template>
  <div>
    <div id="header" :class="{ 'is-fixed': isFixed }" class="container-fuild">
      <div class="header-top container-fuild hidden-xs">
        <div class="page-container header-top-inner">
          <div class="server pull-left">
            <a :href="'tel:' + config.mobile"><span class="glyphicon glyphicon-earphone"></span>{{ config.mobile }}</a>
            <a :href="'mailto:' + config.email.trim()"><span class="glyphicon glyphicon-envelope"></span>{{ config.email }}</a>
            <span class="glyphicon glyphicon-time"></span>7×24小时为您服务
          </div>
          <div class="shejiao pull-right">
            <a :href="'tel:' + config.mobile">{{ config.mobileContact }} {{ config.mobile }}</a>
          </div>
        </div>
      </div>
      <div class="header-nav page-container hidden-xs">
        <div class="header-nav-logo">
          <BrandLogo size="md" to="/" />
        </div>
        <ul class="header-nav-wrapper">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
          >
            <a href="javascript:;" @click="handleNav(item, index)">
              {{ item.name }}
              <i class="underline"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="header-nav-m container-fuild visible-xs">
        <div class="header-nav-m-logo">
          <BrandLogo class="center-block" size="sm" to="/" />
        </div>
        <div class="header-nav-m-menu text-center">
          {{ menuName }}
          <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
            <span :class="menuClass"></span>
          </div>
          <ul id="menu" class="header-nav-m-wrapper collapse">
            <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''"
              @click="handleNav(item, index)" data-toggle="collapse" data-target="#menu">
              <a href="javascript:;">{{ item.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="header-placeholder" :class="{ 'is-active': isFixed }" :style="{ height: placeholderHeight + 'px' }"></div>
  </div>
</template>
<script>
import config from '@/config'
import BrandLogo from '@/components/BrandLogo'
export default {
  name: "Header",
  components: { BrandLogo },
  data() {
    return {
      config: config,
      navIndex: 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      isFixed: false,
      placeholderHeight: 130,
      navList: [
        { name: "首页", path: "/", anchor: "#swiper" },
        { name: "产品方案", path: "/home", anchor: "#bigData" },
        { name: "专利资质", path: "/home", anchor: "#certification" },
        { name: "落地案例", path: "/home", anchor: "#customerCase" },
        { name: "相关服务", path: "/service" },
        { name: "新闻动态", path: "/newsinformation" },
        { name: "公司介绍", path: "/companyintroduction" },
        { name: "合作咨询", path: "/contactus" }
      ],
      standaloneRoutes: ['/service', '/newsinformation', '/companyintroduction', '/contactus']
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    this.syncNavByRoute()
    this.$nextTick(() => {
      const header = document.getElementById('header')
      if (header) this.placeholderHeight = header.offsetHeight
    })
  },
  watch: {
    '$route.path'() {
      this.syncNavByRoute()
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.isFixed = (document.documentElement.scrollTop || document.body.scrollTop) > 80
    },
    syncNavByRoute() {
      const path = this.$route.path
      if (this.standaloneRoutes.includes(path)) {
        const idx = this.navList.findIndex(n => n.path === path)
        if (idx >= 0) {
          this.navIndex = idx
          this.menuName = this.navList[idx].name
        }
        return
      }
      if (path === '/home' || path === '/') {
        const stored = sessionStorage.getItem('navIndex')
        if (stored !== null) {
          const si = parseInt(stored, 10)
          const item = this.navList[si]
          if (item && item.anchor) {
            this.navIndex = si
            this.menuName = item.name
            return
          }
        }
        this.navIndex = 0
        this.menuName = '首页'
      }
    },
    handleNav(item, index) {
      this.navIndex = index
      sessionStorage.setItem('navIndex', index)
      this.menuName = item.name
      if (this.standaloneRoutes.includes(item.path)) {
        this.$router.push(item.path)
        return
      }
      const goAnchor = () => {
        if (item.anchor) {
          this.$nextTick(() => {
            const el = document.querySelector(item.anchor)
            if (el) {
              const top = el.getBoundingClientRect().top + window.pageYOffset - (this.isFixed ? 72 : 0)
              window.scrollTo({ top, behavior: 'smooth' })
            }
          })
        }
      }
      if (this.$route.path === '/home' || this.$route.path === '/') {
        goAnchor()
      } else {
        this.$router.push('/home').then(goAnchor)
      }
    },
    menuClick() {
      this.menuClass = this.menuClass === "glyphicon glyphicon-menu-down"
        ? "glyphicon glyphicon-menu-up" : "glyphicon glyphicon-menu-down"
    }
  }
};
</script>
<style scoped>
#header {
  background: rgba(6, 13, 24, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transition: all ease 0.3s;
  box-shadow: 0 1px 0 rgba(56, 139, 253, 0.12);
  border-bottom: 1px solid rgba(56, 139, 253, 0.1);
}
#header.is-fixed {
  background: rgba(6, 13, 24, 0.96);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4), 0 0 40px rgba(26, 111, 181, 0.08);
}
#header .header-top {
  height: 38px;
  color: #fff;
  font-size: 13px;
  line-height: 38px;
  background: linear-gradient(90deg, #1a6fb5, #2E7D32);
}
.header-top-inner { overflow: hidden; }
#header .header-top a {
  color: #fff;
  margin-right: 18px;
  text-decoration: none;
  font-weight: 500;
}
#header .header-top a:hover { text-decoration: underline; }
#header .header-top span { margin: 0 4px; opacity: 0.9; }
#header .header-nav {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#header .header-nav .header-nav-logo {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  min-width: 0;
}
#header .header-nav .header-nav-wrapper {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 4px;
}
#header .header-nav .header-nav-wrapper > li > a {
  color: #cbd5e1;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 14px;
  display: block;
  position: relative;
  text-decoration: none;
  transition: color 0.25s;
}
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  border-radius: 2px;
  background: linear-gradient(90deg, #38bdf8, #4ade80);
  transition: width 0.3s ease;
  box-shadow: 0 0 8px rgba(56, 189, 248, 0.4);
}
#header .header-nav .header-nav-wrapper > li > a:hover { color: #38bdf8; }
#header .header-nav .header-nav-wrapper > li > a:hover .underline { width: 70%; }
#header .header-nav .header-nav-wrapper > li.active > a { color: #38bdf8; }
#header .header-nav .header-nav-wrapper > li.active > a .underline { width: 70%; }
@media screen and (max-width: 997px) {
  /* 移动端 Header 需高于页面内容，否则下拉菜单会被遮挡 */
  #header {
    position: relative;
    z-index: 1100;
  }
  #header .header-nav-m {
    position: relative;
    z-index: 2;
  }
  #header .header-nav-m .header-nav-m-logo {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(6, 13, 24, 0.95);
  }
  #header .header-nav-m .header-nav-m-logo .brand-logo { margin: 0 auto; }
  #header .header-nav-m .header-nav-m-menu {
    color: #fff; height: 48px; font-size: 17px; line-height: 48px;
    background: linear-gradient(90deg, #1a6fb5, #2E7D32);
    position: relative;
  }
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute; top: 50%; right: 20px; margin-top: -20px;
    width: 50px; height: 40px; color: #fff; z-index: 999; font-size: 12px;
  }
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 48px;
    left: 0;
    width: 100%;
    background: #1e3a5f;
    z-index: 100;
    list-style: none;
    padding: 0;
    margin: 0;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);
    border-bottom: 1px solid rgba(56, 139, 253, 0.2);
  }
  #header .header-nav-m .header-nav-m-wrapper.in {
    display: block;
  }
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 44px; line-height: 44px;
    border-bottom: 1px solid rgba(255,255,255,0.12);
    text-align: center;
  }
  #header .header-nav-m .header-nav-m-wrapper > li > a { color: #fff; font-size: 15px; text-decoration: none; }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue